/**
 * Sessie 55 blok 2: het schaderegister op Gezondheid.
 *
 * Eigen leesweg naast de andere blokken (`/api/werkplek/gezondheid/
 * schaderegister`), zodat een trage query de rest van de pagina laat
 * staan. Types staan hier en niet in `lib/werkplek-api.ts` (gedeeld).
 */
import { apiClient } from "@/lib/api";

export interface VervoerderSchade {
  /** "PostNL", "DHL", of "onbekend" als de melding geen vervoerder draagt. */
  vervoerder: string;
  /** Zendingen van deze vervoerder die in het venster bezorgd zijn. */
  zendingen: number;
  /** Schademeldingen (geen test) in het venster. */
  meldingen: number;
  /** Meldingen tegen zendingen, een decimaal; null zonder zendingen. */
  procent: number | null;
}

export interface MerkKwaliteit {
  merk: string;
  aantal: number;
}

export interface SchadePeriode {
  dagen: number;
  begin: string;
  eind: string;
  schade_totaal: number;
  kwaliteit_totaal: number;
  vervoerders: VervoerderSchade[];
  kwaliteit_per_merk: MerkKwaliteit[];
}

export interface Schaderegister {
  perioden: SchadePeriode[];
  /** Klanten met meer dan een melding binnen `venster_maanden`. */
  herhalers: number;
  venster_maanden: number;
  reden_leeg: string | null;
}

export const schaderegisterApi = {
  async haal(): Promise<Schaderegister> {
    const { data } = await apiClient.get<Schaderegister>(
      "/api/werkplek/gezondheid/schaderegister",
    );
    return data;
  },
};
